'use strict';

(function () {
  'use strict';

  angular.module('vnext', ['ngAnimate', 'msUtility', 'msCore', 'msProfile', 'msActivityServices', 'msActivities', 'msTracker', 'msGoals', 'msSleep', 'msProviderConnect', 'translations', 'angularModalService', 'ui.router.default', 'ngStorage', 'ngMessages', 'infinite-scroll']).constant('context', 'core').value('THROTTLE_MILLISECONDS', 250).run(['$rootScope', '$document', '$state', '$location', 'NotifyingSvc', 'loadingScreenSvc', 'ModalService', 'pageTitleSvc', function ($rootScope, $document, $state, $location, NotifyingSvc, loadingScreenSvc, ModalService, pageTitleSvc) {
    loadingScreenSvc.getCreatedLoadingScreen();
    pageTitleSvc.registerEventListeners();

    // Detect query string `?openCoaching` & set localStorage flag
    if ($location.search() && $location.search().openCoaching) {
      localStorage.setItem('openCoaching', true);
    }

    $rootScope.$on('$stateChangeSuccess', function (e, toState, toParams, fromState) {
      if (_.get(toState, 'data.noScroll') || _.get(fromState, 'data.noScroll')) {
        return;
      }
      $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
      if (_.isFunction(ModalService.closeModals)) {
        ModalService.closeModals();
      }
    });

    $rootScope.$state = $state;

    NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPEN_MODAL, function (event, data) {
      $rootScope.isModalOpen = true;
      ModalService.showModal({
        appendElement: angular.element($document[0].getElementById('modalTarget')),
        templateUrl: data.templateUrl || 'vnext/templates/generic-modal.html',
        controller: data.controller || 'GenericModalCtrl',
        controllerAs: data.controllerAs || '$ctrl',
        inputs: data.inputs,
        scope: data.scope,
        locationChangeSuccess: false
      }).then(function (modal) {
        modal.close.then(function (result) {
          $rootScope.isModalOpen = false;
          if (angular.isFunction(data.closeCallback)) {
            data.closeCallback(result);
          }
        });
      });
    });
  }]);
})();